import { ibkApi } from '@ibk/shared-config';
const buildGetContractSummaryQuery = ({ contractId }) => ({
    url: `/v1/benefits/contracts/${contractId}/summary`,
    method: 'GET',
});
const transformContractSummaryResponse = (response) => response.result;
export const contractSummaryApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        getEmissorContractSummary: build.query({
            query: buildGetContractSummaryQuery,
            transformResponse: transformContractSummaryResponse,
        }),
    }),
    overrideExisting: false,
});
export const { useGetEmissorContractSummaryQuery } = contractSummaryApi;
